module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_09.322f6579.png";